module.exports = __webpack_public_path__ + "img/126ne.6915b56e.svg";